import React, { useEffect, useState } from "react";
import { IconButton } from "@mui/material";
import { Avatar, Popover } from "antd";
import InstallMobileOutlinedIcon from "@mui/icons-material/InstallMobileOutlined";
import { useRecoilState } from "recoil";
import { deferredPromptData } from "../../../components/recoil/deferredPromptRecoil";

const InstallButton = ({ onClick, popoverContent }) => (
  <Popover
    arrowPointAtCenter
    placement="bottomRight"
    content={popoverContent}
    overlayClassName="actioncard-popover"
    trigger="click"
  >
    <IconButton
      style={{ padding: 4 }}
      size="large"
      color="inherit"
      onClick={onClick}
    >
      <Avatar
        style={{ backgroundColor: "var(--main-theme-color)" }}
        icon={<InstallMobileOutlinedIcon style={{ marginBottom: 4 }} />}
      />
    </IconButton>
  </Popover>
);

const InstallationIcon = () => {
  const [deferredPrompt, setDeferredPrompt] =
    useRecoilState(deferredPromptData);
  const [isIOS, setIsIOS] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);
  const [isMacOS, setIsMacOS] = useState(null);
  const [isSafari, setIsSafari] = useState(null);

  useEffect(() => {
    // Detect iOS
    const userAgent = window.navigator.userAgent.toLowerCase();
    const isIOSDevice =
      /iphone|ipad|ipod|mac/.test(userAgent) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

    const isMacOSDevice =
      navigator.platform.toUpperCase().indexOf("MAC") >= 0 &&
      !navigator.maxTouchPoints;
    const isSafariDevice = /^((?!chrome|android).)*safari/i.test(
      navigator.userAgent
    );

    setIsIOS(isIOSDevice);
    setIsMacOS(isMacOSDevice);
    setIsSafari(isSafariDevice);

    // Check if PWA is already installed
    if (window.navigator.standalone) {
      setIsInstalled(true);
    }

    const handleBeforeInstallPrompt = (event) => {
      setDeferredPrompt(event);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt
      );
    };
  }, []);

  const handleInstallClick = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then(() => {
        setDeferredPrompt(null);
      });
    }
  };

  return (
    <>
      {isIOS
        ? !isInstalled &&
          (isMacOS ? (
            isSafari ? (
              <InstallButton
                popoverContent={
                  <div className="menubar-icon-popover-content">
                    Try using a different browser if you're unable to install the app.
                  </div>
                }
              />
            ) : (
              <IconButton
                style={{ padding: 4 }}
                size="large"
                color="inherit"
                onClick={handleInstallClick}
              >
                <Avatar
                  style={{
                    backgroundColor: "var(--main-theme-color)",
                  }}
                  icon={
                    <InstallMobileOutlinedIcon style={{ marginBottom: 4 }} />
                  }
                />
              </IconButton>
            )
          ) : (
            <InstallButton
              popoverContent={
                <div className="menubar-icon-popover-content">
                  To install this app, tap the <strong>Share</strong> button and
                  select <strong>Add to Home Screen</strong>.
                </div>
              }
            />
          ))
        : deferredPrompt && (
            <IconButton
              style={{ padding: 4 }}
              size="large"
              color="inherit"
              onClick={handleInstallClick}
            >
              <Avatar
                style={{
                  backgroundColor: "var(--main-theme-color)",
                }}
                icon={<InstallMobileOutlinedIcon style={{ marginBottom: 4 }} />}
              />
            </IconButton>
          )}
    </>
  );
};

export default InstallationIcon;
